import { render, staticRenderFns } from "./RecentApplications.vue?vue&type=template&id=63dd6f23&scoped=true&"
import script from "./RecentApplications.vue?vue&type=script&lang=js&"
export * from "./RecentApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd6f23",
  null
  
)

export default component.exports